import type { ChatItem } from '../../../contracts/harness.types';

/** A user message with text or attachments opens a turn; a blank one rides the current turn. */
export const opensChatTurn = (item: ChatItem | undefined): boolean =>
  item?.kind === 'user_message' &&
  (item.text.trim().length > 0 || item.attachments.length > 0);

/**
 * The turn holding `items[index]` ended with a user stop or a recovered
 * failure. Both markers close their turn, so the scan only looks forward.
 */
export const turnEndsStopped = (items: readonly ChatItem[], index: number): boolean => {
  for (let next = index + 1; next < items.length; next += 1) {
    const item = items[next];
    if (opensChatTurn(item)) return false;
    if (item?.kind === 'turn_cancelled_marker' || item?.kind === 'turn_failed')
      return true;
  }
  return false;
};
